import React, { useState } from "react";
import styles from "./ConfirmationModal.module.css";

const CopyJsaModal = ({ isOpen, onCancel, onCopy }) => {
  const [selectedDate, setSelectedDate] = useState("");

  if (!isOpen) return null;

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleCopy = () => {
    if (selectedDate) {
      onCopy(selectedDate);
      setSelectedDate("");
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.modalHeader}>Copy JSA</h2>
        <p className={styles.modalMessage}>Select a date for the new JSA:</p>
        <div className={styles.datePickerContainer}>
          <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            className={styles.datePicker}
          />
        </div>
        <div className={styles.modalButtons}>
          <button className={styles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={styles.confirmButton}
            onClick={handleCopy}
            disabled={!selectedDate}
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default CopyJsaModal;
